module.exports = __webpack_public_path__ + "img/jobget_qr_code.dac53c5.png";